interface CustomPageProps {
  style?:any;
};

export const CustomPage: React.FC & CustomPageProps = (props) => {
  return <div className="ant-page-header" style={(props as any).style}>{props.children}</div>;
};
